import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { WalletKyc } from '../../../../../../../schemas/wallet-kyc-schema';
import FileDropBox from '../../../../../../ui/FileDropBox/FileDropBox';

const filesArray: Array<{
  name: keyof WalletKyc['documents'];
  label: string;
}> = [
  {
    label: 'Upload CAC certificate',
    name: 'cac',
  },
  {
    label: 'Upload memorandum and articles (MEMART)',
    name: 'memart',
  },
  {
    label: 'Upload tax identification number (TIN) document ',
    name: 'tin',
  },
  {
    label: 'Upload utility bill',
    name: 'utility_bill',
  },
  {
    label: 'Upload board resolution document',
    name: 'board_resolution',
  },
  {
    label: 'Upload SCUML',
    name: 'scuml',
  },
];

const corporateAcceptedTypes = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
};

export default () => {
  const { control } = useFormContext<WalletKyc>();

  return (
    <div>
      <h6 className="medium-emphasis-text font-medium">
        Upload Required Documents
      </h6>
      <div className="space-y-4 py-4">
        {filesArray.map(({ label, name }) => (
          <Controller
            control={control}
            name={`documents.${name}`}
            key={name}
            render={({ field, fieldState }) => (
              <div>
                <label className="medium-emphasis-text mb-1 block text-sm">
                  {label}*
                </label>
                <FileDropBox
                  {...field}
                  name={name}
                  value={field.value}
                  onChange={field.onChange}
                  maxFiles={1}
                  maxSize={2}
                  allowPreview
                  allowCropping={false}
                  acceptedTypes={corporateAcceptedTypes as any}
                  errorMessage={fieldState.error?.message}
                />
              </div>
            )}
          />
        ))}
      </div>
    </div>
  );
};
